import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { captureEvent } from '../../../../services/event-capture';
import { ACCESS_AUTHENTICATED } from '../../../../services/route/permissions';
import { ROUTE_MAP } from '../../../../services/route/route-names';
import { transitionToNextRoute } from '../../../../services/route/route-navigation';
import { setSideBar } from '../../../../services/store/modules/app-controls';
import PageHolderContent from '../../../containers/PageHolderContent/PageHolderContent';
import AuthCheck from '../../../helpers/AuthCheck/AuthCheck';
import HeaderBarButton from '../../../layouts/components/HeaderBarButton/HeaderBarButton';
import HeaderBar from '../../../layouts/components/HeaderBar/HeaderBar';
import { back } from '../../../shared/vector-images';
import NotificationsFeedPage from './Tabs/NotificationsFeedPage';

const NotificationsHomeHeaderBar = styled(HeaderBar)`
  background: ${({ theme }) => theme.colors.white};
`;

const NotificationsPage: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const handleCloseNotificationsPage = () => {
    captureEvent({
      type: 'notifications: close notifications page',
      payload: {
        action: 'close notifications page selected',
      },
      sendToAmplitude: true,
    });
    if (location.key) {
      history.goBack();
    } else {
      // fallback if notifications was routed to directly
      transitionToNextRoute(ROUTE_MAP);
    }
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      dispatch(setSideBar()); // TODO: do we need the menu bar?
    }

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  return (
    <PageHolderContent
      headerBarContent={
        <NotificationsHomeHeaderBar
          centerNode="Notifications"
          leftNode={
            <HeaderBarButton
              icon={back()}
              onClick={handleCloseNotificationsPage}
            />
          }
        />
      }
    >
      <AuthCheck authentication={ACCESS_AUTHENTICATED}>
        <NotificationsFeedPage />
      </AuthCheck>
    </PageHolderContent>
  );
};

export default NotificationsPage;
